/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerResponse from './CustomerResponse';
import Options from './Options';

/**
* The GetCustomerResponse model module.
* @module model/GetCustomerResponse
* @version 2020-12-7
*/
export default class GetCustomerResponse {
    /**
    * Constructs a new <code>GetCustomerResponse</code>.
    * 顧客取得レスポンス
    * @alias module:model/GetCustomerResponse
    * @class
    * @param customer {module:model/CustomerResponse} 
    * @param result {module:model/GetCustomerResponse.ResultEnum} 
    */

    constructor(customer, result) {
        
        
        this['customer'] = customer;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetCustomerResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetCustomerResponse} obj Optional instance to populate.
    * @return {module:model/GetCustomerResponse} The populated <code>GetCustomerResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetCustomerResponse();
                        
            
            if (data.hasOwnProperty('customer')) {
                obj['customer'] = CustomerResponse.constructFromObject(data['customer']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/CustomerResponse} customer
    */
    'customer' = undefined;
    /**
    * @member {module:model/GetCustomerResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
